import script from "./LegalPageHero.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalPageHero.vue?vue&type=script&setup=true&lang=js"

import "./LegalPageHero.vue?vue&type=style&index=0&id=aaac780c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaac780c"]])

export default __exports__